import { createRepeatActions } from '@sonar-software/xuder';
import { issuesVisibleGetSlice } from './get';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';

const getActions = issuesVisibleGetSlice.asyncActionCreators;

export const { resetGetIssuesVisible } = getActions;

export const { action: requestGetIssuesVisible, repeatAction: requestGetIssuesVisibleAgain } = createRepeatActions(
	getActions.requestGetIssuesVisible,
	{
		count: 20,
		paginationDirection: PaginationDirection.Forward
	}
);
